import { render, staticRenderFns } from "./selectProducts.vue?vue&type=template&id=5523300e"
import script from "./selectProducts.vue?vue&type=script&lang=js"
export * from "./selectProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports